<template>
  <footer class="site-footer">
    <nav>
      <ul class="level0 bottom_menu_inner footer-grid">
        <div id="bxdynamic_XEVOpk_start" style="display:none"></div>
        <li>
          <a href="/catalog/index.html" class="root-item">продукция</a>
          <ul class="root-item footer-grid">
            <li v-for="(category, id) in cat" :key="id">
              <router-link :to="{ name: 'category', params: { groupId: category.id } }">
                {{ category.name }}</router-link
              >
            </li>
            <li>
              <v-img
                src="/upload/static_files/payments.png"
                class="my-6 d-none d-md-block"
                max-width="300px"
              ></v-img>
            </li>
          </ul>
        </li>
        <div id="bxdynamic_XEVOpk_end" style="display:none"></div>
        <li>
          <a href="/media/index.html">Медиа</a>
          <ul class="right-side">
            <li v-for="(video, index) in videoLinks" :key="index">
              <router-link :to="video.to">{{ video.label }}</router-link>
            </li>
            <!-- <li><span class="news-link" data-url="http://expertsouth.ru/novosti/v-volgograde-otkryt-zavod-po-proizvodstv.html">В ВОЛГОГРАДЕ ОТКРЫТ ЗАВОД ПО ПРОИЗВОДСТВУ СУХИХ СТРОИТЕЛЬНЫХ СМЕСЕЙ</span></li> -->
          </ul>
        </li>

        <!--						<li>
							<span>Сайты Sika</span>
							<ul>
								<li><span class="news-link" data-url="http://www.sika.ru">www.sika.ru</span></li>
								<li><span class="news-link" data-url="http://www.sika.com">www.sika.com</span></li>
								<li><span class="news-link" data-url="http://www.sikafloors.ru">www.sikafloors.ru</span></li>
								<li><span class="news-link" data-url="http://www.sikarepair.ru">www.sikarepair.ru</span></li>
							</ul>
						</li>-->
      </ul>
    </nav>

    <v-img
      src="/upload/static_files/payments.png"
      class="my-6 d-md-none d-block"
      max-width="300px"
    ></v-img>

    <div class="footer-info">
      <p class="footer-phone">
        <b class="ya-phone">
          <a href="tel:+78612413137">+7 (861) 24-13-13-7</a>
          &nbsp;&nbsp;&nbsp;&nbsp;
          <a href="tel:+79883121414">+7 (988) 312-14-14</a>
        </b>
      </p>
      <p class="footer-descr"></p>
      <div class="mobile-social">
        <a
          href="https://www.youtube.com/channel/UCv7nCThKuu8THNqAzf6-9FA"
          target="_blank"
          ><i class="fa fa-youtube"></i></a>
        <a href="https://instagram.com/sikarussia/ " target="_blank"
          ><i class="fa fa-instagram"></i></a>
        <a
          href="https://www.facebook.com/SikaRussia/?ref=bookmarks"
          target="_blank"
          ><i class="fa fa-facebook"></i></a>
        <a href="http://vk.com/sikarussia " target="_blank"
          ><i class="fa fa-vk"></i></a>
      </div>

      <div class="social">
        <a
          href="https://www.youtube.com/channel/UCv7nCThKuu8THNqAzf6-9FA"
          target="_blank"
          ><i class="fa fa-youtube"></i></a>
        <a href="https://instagram.com/sikarussia/ " target="_blank"
          ><i class="fa fa-instagram"></i></a>
        <a
          href="https://www.facebook.com/SikaRussia/?ref=bookmarks"
          target="_blank"
          ><i class="fa fa-facebook"></i></a>
        <a href="http://vk.com/sikarussia " target="_blank"
          ><i class="fa fa-vk"></i></a>
      </div>
    </div>
  </footer>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: mapState(["cat", "videoLinks"]),
};
</script>

<style lang="scss" scoped>
.site-footer {
  .footer-info div a {
    margin: 0 8px 0 0;
  }
  .right-side {
    font-size: 14px;
    li {
      padding: 5px 0;
    }
  }

  .footer-grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 768px) {
    .footer-grid {
      grid-template-columns: 1fr;
    }
  }
}
</style>
